export enum ItemType {
  globalSubmission = 'globalSubmission',
  content = 'content',
  conferenceSession = 'conferenceSession'
}
